<template>
	<div class="header-card">
		<div class="header-card-tabs" v-for="(item, key) in multipleTab" :key="key">
			<div :class="tabTitleClass">{{ item.title }}</div>
			<div
				v-for="(tab, tabIndex) in item.tabs"
				:key="tabIndex"
				class="header-card-tabs-item"
				:class="{
					active: value[key] === tab.value
				}"
				@click="handleClickTab(tab, key)"
			>
				<template v-if="!hasTabSlot(key)">
					{{ tab.label }}
				</template>
				<slot v-else :name="key" :tab="tab"></slot>
			</div>
		</div>

		<div class="header-card-line"></div>

		<xbd-filter
			:value="filterData"
			:filter-list="filterList"
			v-bind="filterConfig"
			@input="handleInput"
			@handleSearch="handleSearch"
			@handleMore="handleMore"
		/>
	</div>
</template>

<script>
/**
 * 头部筛选组件（多个tab筛选）
 * @param {Object} multipleTab - 多个tab筛选项
 * @param {Array} filterList - 筛选项列表
 * @param {Object} filterData - 筛选数据
 * @param {Object} value - 当前选中tab的值
 * @param {Boolean} changeClear - 是否切换tab时清空搜索条件，默认false
 * @param {Object} filterConfig - 筛选配置
 * @param {String} tabTitleClass - 自定义tab标题class
 *
 * @event handleSearch - 点击搜索按钮
 * @event tabClick - 点击tab
 * @event handleMore - 点击更多
 *
 * @slot multipleTab.key - tab自定义内容（slot名称为multipleTab单项的key值）
 */

import XbdFilter from "@/components/XbdFilter";

export default {
	name: "HeadMultipleFilter",
	components: {
		XbdFilter
	},
	props: {
		multipleTab: {
			type: Object,
			default: () => ({}),
			required: true
		},
		filterList: {
			type: Array,
			default: () => [],
			required: true
		},
		filterData: {
			type: Object,
			default: () => ({})
		},
		value: {
			type: Object,
			default: () => ({})
		},
		/**
		 * 是否切换tab时清空搜索条件，默认false
		 * @type {Boolean}
		 */
		changeClear: {
			type: Boolean,
			default: false
		},
		filterConfig: {
			type: Object,
			default: () => ({})
		},
		tabTitleClass: {
			type: String,
			default: ""
		}
	},
	methods: {
		handleSearch() {
			this.$emit("search", this.filterData);
		},
		handleClickTab(tab, key) {
			const newValue = { ...this.value, [key]: tab.value };

			if (this.changeClear) {
				this.$emit("update:filterData", {});
			}

			this.$emit("input", newValue);
			this.$emit("tabClick", tab.value, key);
			this.handleSearch();
		},
		handleMore(value) {
			this.$emit("handleMore", value);
		},
		handleInput(value) {
			this.$emit("handleInput", value);
			this.$emit("update:filterData", value);
		}
	},
	computed: {
		hasTabSlot() {
			return (key) => {
				return Boolean(this.$slots[key]) || Boolean(this.$scopedSlots[key]);
			};
		}
	}
};
</script>

<style scoped lang="scss">
.header-card {
	border-radius: 4px;
	padding: 19px 16px 0;
	box-sizing: border-box;
	width: 100%;
	background: #fff;
	padding-bottom: 16px;

	&-tabs {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		color: #999999;
		font-size: 14px;
		align-items: center;
		justify-content: flex-start;
		margin-bottom: 8px;
		box-sizing: border-box;

		& > :first-child {
			margin-right: 16px;
			margin-bottom: 8px;
			color: #3c424d;
			font-family: "PingFang SC";
			font-size: 14px;
			font-style: normal;
			font-weight: 400;
			line-height: 22px;
		}

		&-item {
			display: flex;
			align-items: center;
			color: #74798a;
			font-family: "PingFang SC";
			font-size: 14px;
			font-style: normal;
			font-weight: 400;
			line-height: 22px;
			margin-right: 16px;
			padding: 3px 8px;
			margin-bottom: 8px;
			cursor: pointer;

			&.active {
				gap: 8px;
				border-radius: 2px;
				background: #f2f3f5;
				color: #095ce6;
				font-family: "PingFang SC";
				font-size: 14px;
				font-style: normal;
				font-weight: 400;
				line-height: 22px;
			}
		}
	}

	&-line {
		height: 1px;
		width: 100%;
		background: #e7e8eb;
		margin-bottom: 16px;
	}
}
</style>
